<template>
    <div>
        <div class="md:flex md:items-center md:justify-between">
            <div class="min-w-0 flex-1">
                <router-link
                    :to="{ name: 'editVenue' }"
                    class="mb-2 flex items-center text-sm text-gray-500 inline-flex"
                >
                    <base-back-icon />
                    <span>Settings</span>
                </router-link>
                <base-page-title title="Stream Integration" />
            </div>

            <BaseSpinner :isLoading="isLoading" />
        </div>
        <div>
            <div class="mt-4 md:grid md:grid-cols-3 md:gap-6">
                <div class="md:col-span-1">
                    <div class="sm:pl-0 sm:pr-5">
                        <h3
                            class="text-base font-semibold leading-6 text-gray-800"
                        >
                            Details
                        </h3>
                        <p class="mt-2 text-sm text-gray-500">
                            Configure Stream integration settings for your venue.
                        </p>
                    </div>
                </div>
                <div class="mt-5 md:col-span-2 md:mt-0">
                    <div class="shadow sm:overflow-hidden sm:rounded-md">
                        <div class="space-y-6 bg-white px-4 py-5 sm:p-6">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3 sm:col-span-2">
                                    <toggle-switch
                                        label="Buffer Orders"
                                        v-model="settings.bufferOrders"
                                    />
                                </div>
                                <div
                                    v-if="settings.bufferOrders"
                                    class="col-span-3 sm:col-span-2"
                                >
                                    <base-input-field
                                        label="Buffer Value"
                                        id="buffer"
                                        type="number"
                                        v-model.number="settings.buffer"
                                        :errors="$v.settings.buffer.$error"
                                        error-message="Buffer value must be greater than 0"
                                        placeholder="e.g. 5"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <BaseSpacerWithRuler />

        <div class="my-6 ml-4 flex flex-shrink-0 justify-end">
            <span class="inline-flex rounded-md shadow-sm" @click="saveVenue">
                <button
                    type="button"
                    class="focus:outline-none relative inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium leading-5 text-white hover:bg-indigo-500 focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                    :disabled="isLoading"
                >
                    Save
                </button>
            </span>
        </div>
    </div>
</template>

<script>
import ToggleSwitch from '@/components/formComponents/ToggleSwitch';
import { minValue, requiredIf } from 'vuelidate/lib/validators';

export default {
    name: 'StreamSettings',
    metaInfo: {
        title: 'Stream Settings'
    },
    props: ['venueId', 'venue'],
    components: {
        ToggleSwitch
    },
    validations: {
        settings: {
            buffer: {
                required: requiredIf(function () {
                    return this.settings.bufferOrders;
                }),
                minValue: minValue(1)
            }
        }
    },
    data() {
        return {
            isLoading: false,
            settings: {
                bufferOrders: false,
                buffer: null
            }
        };
    },
    mounted() {
        if (this.venue.integrations && this.venue.integrations.stream) {
            this.settings.bufferOrders = this.venue.integrations.stream.bufferOrders || false;
            this.settings.buffer = this.venue.integrations.stream.buffer || null;
        }
    },
    methods: {
        async saveVenue() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            }

            try {
                this.isLoading = true;

                const streamConfig = {
                    bufferOrders: this.settings.bufferOrders
                };

                if (this.settings.bufferOrders && this.settings.buffer) {
                    streamConfig.buffer = this.settings.buffer;
                }

                const payload = {
                    integrations: {
                        ...this.venue.integrations,
                        stream: streamConfig
                    }
                };

                await this.$axios.put(
                    '/venues/' + this.venueId,
                    payload
                );

                this.$notify({
                    group: 'settings',
                    title: 'Settings saved'
                });
            } catch (e) {
                throw new Error(`API ${e}`);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
